import { render, staticRenderFns } from "./CoozzyCardText.vue?vue&type=template&id=0f2fae73&scoped=true"
import script from "./CoozzyCardText.vue?vue&type=script&lang=js"
export * from "./CoozzyCardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fae73",
  null
  
)

export default component.exports